(function(){function initCal(root){
  
  
  var DOW=["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];
  var MON=["January","February","March","April","May","June","July","August","September","October","November","December"];
  var data;
  try{data=JSON.parse(root.querySelector('[data-sa-data]').textContent)||[];}catch(e){data=[];}
  data.forEach(function(c){var p=c.date.split("-");c.dt=new Date(+p[0],+p[1]-1,+p[2]);c.m=c.dt.getMonth();c.y=c.dt.getFullYear();c.day=c.dt.getDate();c.dow=DOW[c.dt.getDay()];});
  data.sort(function(a,b){return a.dt-b.dt;});
  var _t=new Date();_t.setHours(0,0,0,0);
  data=data.filter(function(c){return c.dt>=_t;});
  var locBadge=function(l){return l?'<span class="sa-cal__loc">'+l+'</span>':'';};
  var priceHtml=function(c){return (!c.cents||c.cents===0)?'<span class="sa-cal__tbc">Price TBC</span>':'R'+(c.cents/100).toFixed(0)+' <small>pp</small>';};
  var listEl=root.querySelector('[data-sa-list]'),gridEl=root.querySelector('[data-sa-grid]'),monthsEl=root.querySelector('[data-sa-months]'),emptyEl=root.querySelector('[data-sa-empty]');

  if(!data.length){emptyEl.hidden=false;root.querySelector('.sa-cal__toolbar').style.display='none';return;}

  // List
  var lh="",lastKey="";
  data.forEach(function(c){
    var key=c.m+"-"+c.y;
    if(key!==lastKey){lh+='<div class="sa-cal__month-label">'+MON[c.m]+' '+c.y+'</div>';lastKey=key;}
    var side=(!c.cents||c.cents===0)?'<div class="sa-cal__tbc">Details TBC</div>':'<div class="sa-cal__price">R'+(c.cents/100).toFixed(0)+' <small>pp</small></div>';
    var act=c.postponed?'<span class="sa-cal__sold">Postponed</span>':(c.available?'<a class="sa-cal__book" href="'+c.url+'">Book</a>':'<span class="sa-cal__sold">Sold out</span>');
    lh+='<article class="sa-cal__card"><div class="sa-cal__chip"><div class="sa-cal__dow">'+c.dow+'</div><div class="sa-cal__dnum">'+c.day+'</div></div>'+
        '<div><h3 class="sa-cal__ctitle">'+c.title+'</h3><div class="sa-cal__meta">'+(c.time?'<span>'+c.time+'</span><span class="sa-cal__d"></span>':'')+locBadge(c.loc)+'</div></div>'+
        '<div class="sa-cal__side">'+side+act+'</div></article>';
  });
  listEl.innerHTML=lh;

  // Grid — build one mini-month per month that has classes
  var byMonth={};
  data.forEach(function(c,i){var k=c.y+"-"+("0"+c.m).slice(-2);(byMonth[k]=byMonth[k]||{list:[],y:c.y,m:c.m})[""];byMonth[k].list.push(i);});
  var keys=Object.keys(byMonth).sort();
  var gh="";
  keys.forEach(function(k){
    var mm=byMonth[k],days={};mm.list.forEach(function(i){days[data[i].day]=i;});
    var first=new Date(mm.y,mm.m,1).getDay(),dim=new Date(mm.y,mm.m+1,0).getDate();
    gh+='<div class="sa-cal__cal"><h4>'+MON[mm.m]+' '+mm.y+'</h4><div class="sa-cal__dowrow">'+DOW.map(function(d){return '<span>'+d[0]+'</span>';}).join("")+'</div><div class="sa-cal__days">';
    for(var d=1;d<=dim;d++){
      var st=(d===1)?' style="grid-column-start:'+(first+1)+'"':'';
      if(days[d]!==undefined)gh+='<button type="button" class="sa-cal__day has" data-i="'+days[d]+'"'+st+'>'+d+'<span class="pip"></span></button>';
      else gh+='<div class="sa-cal__day"'+st+'>'+d+'</div>';
    }
    gh+='</div></div>';
  });
  monthsEl.innerHTML=gh;

  // Modal
  var modal=document.createElement('div');modal.className='sa-cal__modal';
  modal.innerHTML='<div class="sa-cal__sheet" role="dialog" aria-modal="true"><button class="sa-cal__x" aria-label="Close">&times;</button><div class="sa-cal__dow" data-m-dow></div><h3 data-m-title></h3><div class="sa-cal__row"><span>Date</span><span data-m-date></span></div><div class="sa-cal__row"><span>Time</span><span data-m-time></span></div><div class="sa-cal__row"><span>Location</span><span data-m-loc></span></div><div class="sa-cal__row"><span>Price</span><span data-m-price></span></div><a class="sa-cal__book" data-m-book href="#">Book this class</a></div>';
  document.body.appendChild(modal);
  var close=function(){modal.classList.remove('is-open');};
  modal.addEventListener('click',function(e){if(e.target===modal)close();});
  modal.querySelector('.sa-cal__x').addEventListener('click',close);
  document.addEventListener('keydown',function(e){if(e.key==='Escape')close();});
  monthsEl.addEventListener('click',function(e){
    var b=e.target.closest('.sa-cal__day.has');if(!b)return;
    var c=data[+b.dataset.i];
    modal.querySelector('[data-m-dow]').textContent=c.postponed?'Postponed':'Cooking class';
    modal.querySelector('[data-m-title]').textContent=c.title;
    modal.querySelector('[data-m-date]').textContent=c.dow+', '+c.day+' '+MON[c.m]+' '+c.y;
    modal.querySelector('[data-m-time]').textContent=c.time||'—';
    modal.querySelector('[data-m-loc]').textContent=c.loc||'—';
    modal.querySelector('[data-m-price]').innerHTML=(!c.cents||c.cents===0)?'To be confirmed':'R'+(c.cents/100).toFixed(0)+' pp';
    var bk=modal.querySelector('[data-m-book]');
    if(c.available&&!c.postponed){bk.style.display='block';bk.href=c.url;}else{bk.style.display='none';}
    modal.classList.add('is-open');
  });

  // Toggle
  var tabs=root.querySelectorAll('.sa-cal__tab');
  function setView(v){
    listEl.hidden=(v!=='list');gridEl.hidden=(v!=='grid');
    tabs.forEach(function(t){var on=t.dataset.view===v;t.classList.toggle('is-active',on);t.setAttribute('aria-selected',on);});
  }
  tabs.forEach(function(t){t.addEventListener('click',function(){setView(t.dataset.view);});});
  setView(root.dataset.saDefault==='grid'?'grid':'list');
}document.querySelectorAll('.sa-cal').forEach(initCal);})();
